import React, {useState} from 'react';
import PasswordInput from './PasswordInput.tsx';

interface PasswordInputWithValidationProps {
    outerChangeHandler?:any
    additionalHintUpper?:boolean,
    label?:string,
    error?:string,
    spacing?:number,
};

const PasswordInputWithValidation = ({
    outerChangeHandler,
    additionalHintUpper = false,
    label = 'Neues Passwort',
    error,
    spacing = 0,
}:PasswordInputWithValidationProps) => {

    
    const [formData, setFormData] = useState<any>({
        newpassword: '',
        repeatpassword: ''
    });
    
    const [settingNewPassword, setSettingNewPassword] = useState<boolean>(false);
    const [passwordsMatch, setPasswordsMatch] = useState<boolean>(false);
    const [passwordLongEnough, setPasswordLongEnough] = useState<boolean>(false);
    const [passwordIncludesCapitalLetter, setPasswordIncludesCapitalLetter] = useState<boolean>(false);
    const [passwordIncludesLowerLetter, setPasswordIncludesLowerLetter] = useState<boolean>(false);
    const [passwordIncludesSpecialCharacter, setPasswordIncludesSpecialCharacter] = useState<boolean>(false);
    const [passwordIncludesNumber, setPasswordIncludesNumber] = useState<boolean>(false);
    const [passwordIncludesInvalidChars, setPasswordIncludesInvalidChars] = useState<string>('');

    const specialChars = /[!"#$%&/'*+-.:,;=?@^_~()[\]{}]/;
    const invalidPWChars = /[!"#$%&/'*+-.:,;=?@^_~()[\]{}a-z0-9]/gi;
    

    const handleChange = (event, name = '', value = null) => {
        let formDataClone = structuredClone(formData);
        formDataClone = { ...formDataClone, [name ? name : event.target.name]: (value ? value : event.target.value) }
        let newpassword = formDataClone.newpassword;
        let repeatpassword = formDataClone.repeatpassword;
        
        setSettingNewPassword(newpassword.length > 0);

        let passwordContaisErrors = false;

        if (newpassword === repeatpassword) {
            setPasswordsMatch(true);
        } else {
            setPasswordsMatch(false);
            passwordContaisErrors = true;
        }

        if (newpassword.length > 8) {
            setPasswordLongEnough(true);
        } else {
            setPasswordLongEnough(false);
            passwordContaisErrors = true;
        }

        if (newpassword !== newpassword.toLowerCase()) {
            setPasswordIncludesCapitalLetter(true);
        } else {
            setPasswordIncludesCapitalLetter(false);
            passwordContaisErrors = true;
        }

        if (newpassword !== newpassword.toUpperCase()) {
            setPasswordIncludesLowerLetter(true);
        } else {
            setPasswordIncludesLowerLetter(false);
            passwordContaisErrors = true;
        }

        if (specialChars.test(newpassword)) {
            setPasswordIncludesSpecialCharacter(true);
        } else {
            setPasswordIncludesSpecialCharacter(false);
            passwordContaisErrors = true;
        }

        if (newpassword.replace(/\D/g,'').length > 0) {
            setPasswordIncludesNumber(true);
        } else {
            setPasswordIncludesNumber(false);
            passwordContaisErrors = true;
        }

        let invalidNewPasswordChars = newpassword.replace(invalidPWChars, '');
        let invalidRepeatPasswordChars = repeatpassword.replace(invalidPWChars, '');
        let invalidChars = '';
        if (invalidNewPasswordChars.length > 0) {
            invalidChars += invalidNewPasswordChars;
        }
        if (invalidRepeatPasswordChars.length > 0) {
            invalidChars += invalidRepeatPasswordChars;
        }
        let arrayOfInvalidChars = invalidChars.split('');
        if (arrayOfInvalidChars.length > 0) {
            arrayOfInvalidChars = [...new Set(arrayOfInvalidChars)];
            setPasswordIncludesInvalidChars(arrayOfInvalidChars.join(''));
            passwordContaisErrors = true;
        } else {
            setPasswordIncludesInvalidChars('');
        }

        setFormData(formDataClone);

        outerChangeHandler(formDataClone, !passwordContaisErrors);
    };

    return (
        <>
            { additionalHintUpper && (
                <div>
                    <p className='text-xs'>Bitte vergeben Sie nun ein neues Passwort.</p>
                    <p className='text-xs'>Wir empfehlen, ein möglichst langes und komplexes Passwort. Speichern Sie dieses idealerweise auch in einem vertrauenswürdigen Passwort-Manager.</p>
                    <p className='text-xs'>Nach erfolgreicher Kontoaktivierung und erneutem Login können Sie später unter dem Menüpunkt „Kontoeinstellungen“ Ihr Passwort jederzeit ändern.</p>
                    <p className='text-xs'>Wir empfehlen auch, die Zwei-Faktor Authentifizierung zum Schutz Ihres Kontos und Ihrer persönlichen Daten zu aktivieren.</p>
                </div>
            ) }
            <PasswordInput
                onChange={handleChange}
                value={formData.newpassword}
                placeholder={label || 'Neues Passwort'}
                name='newpassword'
                label={label || 'Neues Passwort'}
                showToggle={true}
                autocomplete='new-password'
                className={error ? 'invalid' : ''}
                help={'Das neue Passwort muss mindestens 8 Zeichen, einen Großbuchstaben, einen Kleinbuchstaben, ein Sonderzeichen und eine Zahl enthalten.' + (!additionalHintUpper ? ' Wir empfehlen, ein möglichst langes und komplexes Passwort. Speichern Sie dieses in einem vertrauenswürdigen Passwort-Manager.' : '')}
            />
            <PasswordInput
                onChange={handleChange}
                value={formData.repeatpassword}
                placeholder={label ? label + ' wiederholen' : 'Neues Passwort wiederholen'}
                name='repeatpassword'
                label={label ? label + ' wiederholen' : 'Neues Passwort wiederholen'}
                showToggle={true}
                autocomplete='new-password'
                className={error ? 'invalid' : ''}
            />
            { error && (
                <span className='form-error' role='alert'>{ error }</span>
            ) }
            { settingNewPassword && (
                <div className="form-group">
                    <div className={`mb-${spacing}`}></div>
                    <div className="pw-validation-area">
                        <ul>
                            <li className={passwordsMatch ? 'cleared' : ''}>Passwörter müssen übereinstimmen</li>
                            <li className={passwordLongEnough ? 'cleared' : ''}>Passwörter müssen mindestens 8 Zeichen lang sein</li>
                            <li className={passwordIncludesCapitalLetter ? 'cleared' : ''}>Passwörter müssen mindestens einen Großbuchstaben enthalten</li>
                            <li className={passwordIncludesLowerLetter ? 'cleared' : ''}>Passwörter müssen mindestens einen Kleinbuchstaben enthalten</li>
                            <li className={passwordIncludesSpecialCharacter ? 'cleared' : ''}>Passwörter müssen mindestens ein Sonderzeichen enthalten <em>&#x21;&#x22;&#x23;&#x24;&#x25;&#x26;&#x2F;&#x27;&#x2A;&#x2B;&#x2D;&#x2E;&#x3A;&#x2C;&#x3B;&#x3D;&#x3F;&#x40;&#x5E;&#x5F;&#x7E;&#x28;&#x29;&#x5B;&#x5D;&#x7B;&#x7D;</em></li>
                            <li className={passwordIncludesNumber ? 'cleared' : ''}>Passwörter müssen mindestens eine Zahl enthalten</li>
                            {passwordIncludesInvalidChars ? (
                                <li className='invalid'>Passwörter enthalten invalide Zeichen: { passwordIncludesInvalidChars }</li>
                            ) : ''}
                        </ul>
                    </div>
                </div>
            ) }
        </>
    )
}

export default PasswordInputWithValidation;